import {
  TableColumnModel,
  QueryScopeType,
  QueryStatusType,
  QueryTypeType,
} from "@interfaces/index";

export const QUERY_WIDTHS = {
  sm: "(max-width: 401px)",
  md: "(max-width: 767px)",
  lg: "(max-width: 1023px)",
  xl: "(max-width: 1199px)",
  xxl: "(max-width: 1439px)",
};

export const PROFILE_PAGE_URLS = [
  "/profile",
  "/profile/change-name",
  "/profile/change-phone",
  "/profile/my-businesses",
  "/profile/change-password",
  "/profile/leave",
  "/profile/red-statement",
];
export const SIMPLE_MOBILE_LAYOUT_URLS = [
  "/transactions/create",
  "/transactions/update",
  "/transactions/refund",
  "/faq",
  "/submissions/details/",
];

export const NEIGHBOUR_PAGES = 2;
export const PER_PAGE_VALUES = ["15", "50", "100"];
export const WIDGETS_PER_PAGE = 3;
export const ASSETS_PER_PAGE = 5;

export const TRANSACTION_FILE_EXTENSIONS =
  ".jpg, .jpeg, .png, .pdf, .doc, .xls";
export const ASSET_FILE_EXTENSIONS = ".jpg, .jpeg, .png, .pdf, .doc, .xls";
export const FILE_PREVIEW_EXTENSIONS = ["jpg", "jpeg", "png", "pdf"];
export const QUESTION_FILE_EXTENSIONS = ".jpg, .jpeg, .png, .pdf, .doc, .xls";

export const TABLE_TRANSACTIONS_COLUMNS: TableColumnModel[] = [
  {
    title: "Date",
    width: "w-28",
  },
  {
    title: "Transaction Source",
    width: "w-24",
  },
  {
    title: "Type",
    width: "w-20 xxl:w-36 hidden lg:table-cell",
  },
  {
    title: "Category/Sub Category",
    width: "w-52",
  },
  {
    title: "Asset",
    width: "w-24",
  },
  {
    title: "Period",
    width: "w-28 xl:w-44",
  },
  {
    title: "Attachments",
    width: "w-28 hidden xl:table-cell",
  },
  {
    title: "Status",
    width: "w-32",
  },
  {
    title: "Description",
    width: "w-32 xl:w-44 xxl:w-72 hidden lg:table-cell",
  },
  {
    title: "Amount",
    width: "w-28",
    alignRight: true,
  },
  {
    title: "",
    width: "w-24 min-w-24",
  },
];

export const TABLE_SUBMISSIONS_COLUMNS: TableColumnModel[] = [
  {
    title: "Period",
    width: "w-28 xl:w-44",
  },
  {
    title: "Business",
    width: "w-28 lg:w-44",
  },
  {
    title: "Status",
    width: "w-52 min-w-[170px]",
  },
  {
    title: "Comment",
    width: "w-24 lg:w-52 xl:w-80 xxl:w-96",
  },
  {
    title: "Income",
    width: "w-28",
    alignRight: true,
  },
  {
    title: "Business Expenses",
    width: "w-28",
    alignRight: true,
  },
  {
    title: "Private",
    width: "w-28",
    alignRight: true,
  },
  {
    title: "Profit/Loss",
    width: "w-28",
    alignRight: true,
  },
];

export const TABLE_ASSETS_COLUMNS: TableColumnModel[] = [
  {
    title: "Type",
    width: "w-44 md:w-52 xxl:w-60",
  },
  {
    title: "Asset Name",
    width: "min-w-40 w-auto lg:w-56 xxl:w-72",
  },
  {
    title: "Cost",
    width: "hidden md:table-cell w-28 xxl:w-36",
  },
  {
    title: "Purchase Date",
    width: "hidden md:table-cell w-28 xxl:w-36",
  },
  {
    title: "Comment",
    width: "hidden lg:table-cell w-auto",
  },
  {
    title: "",
    width: "w-6",
  },
];

export const TABLE_DISPOSED_ASSETS_COLUMNS: TableColumnModel[] = [
  {
    title: "Type",
    width: "w-44 md:w-52 xxl:w-60",
  },
  {
    title: "Asset Name",
    width: "min-w-40 w-auto lg:w-56 xxl:w-72",
  },
  {
    title: "Cost",
    width: "hidden md:table-cell w-28 xxl:w-36",
  },
  {
    title: "Sale cost",
    width: "hidden xl:table-cell w-28 xxl:w-36",
  },
  {
    title: "Purchase Date",
    width: "hidden md:table-cell w-28 xxl:w-36",
  },
  {
    title: "Disposal Date",
    width: "hidden xl:table-cell w-28 xxl:w-36",
  },
  {
    title: "Comment",
    width: "hidden lg:table-cell w-auto",
  },
  {
    title: "",
    width: "w-6",
  },
];

export const TABLE_MILEAGE_DI_COLUMNS: TableColumnModel[] = [
  {
    title: "Date range",
    width: "w-56",
  },
  {
    title: "Period",
    width: "w-28 xl:w-44",
  },
  {
    title: "Asset Name",
    width: "min-w-40 w-auto lg:w-56 xxl:w-72",
  },
  {
    title: "Business miles",
    width: "w-24",
  },
  {
    title: "Private miles",
    width: "w-20",
  },
  {
    title: "Total miles",
    width: "w-16",
  },
  {
    title: "Private use",
    width: "w-16",
  },
  {
    title: "",
    width: "w-24 min-w-24",
  },
];

export const TABLE_MILEAGE_NO_DI_COLUMNS: TableColumnModel[] = [
  {
    title: "Date range",
    width: "w-56",
  },
  {
    title: "Period",
    width: "w-28 xl:w-44",
  },
  {
    title: "Asset Name",
    width: "min-w-40 w-auto lg:w-56 xxl:w-72",
  },
  {
    title: "Business miles",
    width: "w-24",
  },
  {
    title: "Total Miles/Tax Year",
    width: "w-28",
  },
  {
    title: "Mileage",
    width: "w-20",
  },
  {
    title: "",
    width: "w-24 min-w-24",
  },
];

export const PURCHASE_TYPES = {
  purchased_outright: "Purchased Outright",
  hire_purchase: "Hire Purchase",
  personal_contract_purchase: "Personal Contract Purchase",
  loan: "Loan",
  lease: "Lease/Franchise",
  mortgage: "Mortgage",
  finance: "Finance",
};

export const ASSET_NO_AGREEMENT_ATTACHMENTS_NAME =
  "notApplicableAgreement_OR_uploadLaterAgreement";
export const ASSET_NO_INVOICE_ATTACHMENTS_NAME =
  "notApplicableInvoice_OR_uploadLaterInvoice";

export const DAYS_BEFORE_END_SUBMISSION_PERIOD = 14;

export const DAYS_UPDATE_BANNER_INACTIVE = 7;
export const DAYS_UPLOAD_LATER_BANNER = 1;

export const TUTORIAL_MODAL_WINDOW = "!modal_window";

export const LENGTH_USER_NAME_FOR_HEADER = 22;

export const QUERY_SCOPE_LABELS: Record<QueryScopeType, string> = {
  submission: "Submission queries",
  tax_return: "Tax return Queries",
};

export const QUERY_TYPE_LABELS: Record<QueryTypeType, string> = {
  action_required: "Action Required",
  clarification: "Clarification",
};

export const QUERY_STATUS_LABELS: Record<QueryStatusType, string> = {
  awaiting_client: "Action Required",
  awaiting_fbtc: "Awaiting FBTC",
  resolved: "Resolved",
};

// Backend limit for POST /transactions/batch
export const BULK_TRANSACTIONS_MAX = 15;
